"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MSFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_158)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_158`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.52002 0H27.48V24H-8.52002V0Z",
					fill: "#1B4991"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.8098 7.48773V14.9614C13.8098 18.6035 18.5677 19.7193 18.5677 19.7193C18.5677 19.7193 23.3256 18.6035 23.3256 14.9614V7.48773H13.8098Z",
					fill: "#00A2B8",
					stroke: "white",
					strokeWidth: .210526
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.915 14.9263C13.915 18.4912 18.5677 19.579 18.5677 19.579C18.5677 19.579 23.2203 18.4842 23.2203 14.9263H13.915Z",
					fill: "#A35023"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.6098 10.8842H19.2484V9.52283H17.887V10.8842H16.5326V12.2456H17.887V16.3228H19.2484V12.2456H20.6098V10.8842Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.44489 0V2.14737L6.27296 3.90877H9.44489V8.07018H5.29752L9.44489 10.3719V11.9789H7.57121L2.41331 9.10877V11.9789H-1.48844V8.56842L-7.62879 11.9789H-8.52002V9.83158L-5.34809 8.07018H-8.52002V3.90877H-4.37265L-8.52002 1.6V0H-6.64634L-1.48844 2.86316V0H2.41331V3.41053L8.55367 0H9.44489Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.58524 0H-0.66037V4.86316H-8.52002V7.10877H-0.66037V11.9789H1.58524V7.10877H9.44489V4.86316H1.58524V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.41333 8.07019L9.44491 11.979V10.8702L4.40631 8.07019H2.41333Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.41333 8.07019L9.44491 11.979V10.8702L4.40631 8.07019H2.41333Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.41331 8.07019L9.44489 11.979V10.8702L4.4063 8.07019H2.41331ZM-3.48142 8.07019L-8.52002 10.8702V11.979L-1.48844 8.07019H-3.48142Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.48844 3.90175L-8.52002 0V1.10175L-3.48142 3.90175H-1.48844ZM4.4063 3.90175L9.44489 1.10175V0L2.41331 3.90175H4.4063Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_158`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MSFlag };
